import React, {memo, useMemo, useState} from 'react';
import Container from '@/components/atoms/Container';
import styles from './ImpactStats.module.scss';

// MUI-free copy of Ui-components/home/impact-stats (index only — its OrbitDiagram and
// decorations files are not used by this section).

export type ImpactStat = {
    tag: string;
    value: string;
    heading: string;
    /** Optional supporting line — the homepage cards run on the short headline alone. */
    description?: string;
};

const ImpactStats = ({contentData, eyebrow}: {contentData: ImpactStat[]; eyebrow?: string}) => {
    const total = contentData?.length ?? 0;
    // Tripled so the visible window is always covered by real cards; the track scrolls
    // exactly one copy's width (33.3333%) and then jumps back to 0% at the same visual
    // position, so the CSS animation loops with no seam.
    const tripled = useMemo(() => [...contentData, ...contentData, ...contentData], [contentData]);
    const [paused, setPaused] = useState(false);

    if (!total) return null;

    const durationS = total * 4;
    const trackStyle: React.CSSProperties = {animationDuration: `${durationS}s`};

    return (
        <div className={styles.section} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
            <Container className={styles.inner}>
                {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
                <h2 className={`font-headers ${styles.heading}`}>Proven Enterprise Delivery</h2>

                <div className={styles.divider} />

                <div className={styles.trackViewport}>
                    <div className={`impact-stats-track ${styles.track}${paused ? ` ${styles.paused}` : ''}`} style={trackStyle}>
                        {tripled.map((item, i) => (
                            <div key={`${item.heading}-${i}`} className={styles.card}>
                                <p className={`font-headers impact-stat-value ${styles.value}`}>{item.value}</p>
                                <p className={`font-regular-text ${styles.cardHeading}`}>{item.heading}</p>
                                {item.description && <p className={`font-regular-text ${styles.cardDescription}`}>{item.description}</p>}
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default memo(ImpactStats);
